import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { Router } from '@angular/router';
import { StudentAssignmentService } from '@app/infrastructure/core/services/api/student-assignment.service';
import { UserStateService } from '@app/infrastructure/core/services/state/user-state.service';
import {
  IStudentGradeUnitDayListItemDTO,
  StudentGradeUnitDayListItemDTO,
} from '@app/infrastructure/models/grade-unit/student-grade-unit-day';
import { StatusEnum } from '@app/infrastructure/models/status';
import {
  IStudentAssignmentDTO,
  IStudentAssignmentRequest,
  StudentAssignmentRequest,
  StudentAssignmentStatus,
} from '@app/infrastructure/models/student-assignment';

@Component({
  selector: 'app-student-grade-unit-day',
  template: `
    <app-student-grade-unit-day-presentation
      [gradeUnitDay]="gradeUnitDay"
      [studentAssignment]="studentAssignment"
      [altText]="altText"
      [dayText]="dayText"
      (emitNavigate)="navigate()"
      (emitStartAssignment)="startAssignment($event)"
    >
    </app-student-grade-unit-day-presentation>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StudentGradeUnitDaySmartComponent implements OnInit {
  @Input() gradeUnitDay: IStudentGradeUnitDayListItemDTO =
    new StudentGradeUnitDayListItemDTO();
  public studentAssignment: IStudentAssignmentDTO;
  public studentId: string = '';
  public dayText: string;
  public altText: string;
  constructor(
    private router: Router,
    private userStateService: UserStateService,
    private studentAssignmentService: StudentAssignmentService,
  ) {}

  ngOnInit(): void {
    this.getStudentId();
    this.studentAssignment = this.gradeUnitDay.studentAssignments[0] || null;
    this.dayText = this.getAssignmentStatus();

    this.altText = `Day ${this.gradeUnitDay.dayNumber} Cover Photo`;
  }

  getStudentId(): void {
    this.userStateService.getUserSession().subscribe((user) => {
      this.studentId = user?.student?.id;
    });
  }

  navigate(): void {
    const dayPath = [`${this.router.url}/${this.gradeUnitDay.dayNumber}`];
    this.router.navigate(dayPath);
  }

  startAssignment(classroomAssignmentId: number): void {
    const payload: IStudentAssignmentRequest = new StudentAssignmentRequest({
      gradeUnitId: this.gradeUnitDay.unitId,
      gradeUnitDayId: this.gradeUnitDay.dayId,
      classroomAssignmentId,
    });

    this.studentAssignmentService
      .createStudentAssignment(this.studentId, payload)
      .subscribe(() => {
        this.navigate();
      });
  }

  getAssignmentStatus(): StudentAssignmentStatus | StatusEnum {
    const today = new Date(new Date().setHours(0, 0, 0, 0));
    if (
      this.studentAssignment &&
      (this.studentAssignment.assignmentStatus ===
        StudentAssignmentStatus.COMPLETED ||
        this.studentAssignment.completedAt)
    ) {
      return StudentAssignmentStatus.COMPLETED;
    }
    if (today > new Date(this.gradeUnitDay.dueDate)) {
      return StudentAssignmentStatus.WRAP_UP;
    }
    return this.studentAssignment
      ? this.studentAssignment.assignmentStatus
      : this.gradeUnitDay.assignmentStatus;
  }
}
